export enum BillingsPlanEntryTaxiDriverAddParamsContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HALTING = "CHARGE_HALTING",
  CHARGE_HIGHWAYS = "CHARGE_HIGHWAY",
  BONUS_FAVORABLE_DISTANCE = "BONUS_FAVORABLE_DISTANCE",
  BONUS_OTHER = "BONUS_OTHER",
  PENALTY_WRONG_ROUTE = "PENALTY_WRONG_ROUTE",
  PENALTY_BEING_LATE = "PENALTY_BEING_LATE",
  PENALTY_INCOMPATIBLE_CAR = "PENALTY_INCOMPATIBLE_CAR",
  PENALTY_OTHER = "PENALTY_OTHER",
  BASE_AMOUNT_EXTERNAL_TAXI = "BASE_AMOUNT_EXTERNAL_TAXI",
  CONTRACT_CORRECTION_RATE = "CONTRACT_CORRECTION_RATE",
}

export type BillingsPlanEntryTaxiDriverAddParamsContractCorrectionContributionBaseAmountExternalTaxi =
  {
    type: BillingsPlanEntryTaxiDriverAddParamsContributionType.BASE_AMOUNT_EXTERNAL_TAXI;
    distance: number;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverAddParamsContractCorrectionContributionOtherRate =
  {
    type: BillingsPlanEntryTaxiDriverAddParamsContributionType.CONTRACT_CORRECTION_RATE;
    rate: number;
  };

export type BillingsPlanEntryTaxiDriverAddParamsBonusContributionFavorableDistance =
  {
    type: BillingsPlanEntryTaxiDriverAddParamsContributionType.BONUS_FAVORABLE_DISTANCE;
    comment: string | null;
    distance: number;
    rate: number;
  };

export type BillingsPlanEntryTaxiDriverAddParamsBonusContributionOther = {
  type: BillingsPlanEntryTaxiDriverAddParamsContributionType.BONUS_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionWrongRoute =
  {
    type: BillingsPlanEntryTaxiDriverAddParamsContributionType.PENALTY_WRONG_ROUTE;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionBeingLate = {
  type: BillingsPlanEntryTaxiDriverAddParamsContributionType.PENALTY_BEING_LATE;
  comment: string | null;
  amount: number;
};

export type BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionIncompatibleCar =
  {
    type: BillingsPlanEntryTaxiDriverAddParamsContributionType.PENALTY_INCOMPATIBLE_CAR;
    comment: string | null;
    amount: number;
  };

export type BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionOther = {
  type: BillingsPlanEntryTaxiDriverAddParamsContributionType.PENALTY_OTHER;
  comment: string | null;
  amount: number;
};

export type BillingsPlanEntryTaxiDriverAddParamsContractCorrectionContribution =

    | BillingsPlanEntryTaxiDriverAddParamsContractCorrectionContributionBaseAmountExternalTaxi
    | BillingsPlanEntryTaxiDriverAddParamsContractCorrectionContributionOtherRate;

export type BillingsPlanEntryTaxiDriverAddParamsBonusContribution =
  | BillingsPlanEntryTaxiDriverAddParamsBonusContributionFavorableDistance
  | BillingsPlanEntryTaxiDriverAddParamsBonusContributionOther;

export type BillingsPlanEntryTaxiDriverAddParamsPenaltyContribution =
  | BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionWrongRoute
  | BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionBeingLate
  | BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionIncompatibleCar
  | BillingsPlanEntryTaxiDriverAddParamsPenaltyContributionOther;

export type BillingsPlanEntryTaxiDriverAddParamsContribution =
  | BillingsPlanEntryTaxiDriverAddParamsBonusContribution
  | BillingsPlanEntryTaxiDriverAddParamsPenaltyContribution
  | BillingsPlanEntryTaxiDriverAddParamsContractCorrectionContribution;

export type BillingsPlanEntryTaxiDriverAddParamsBillingNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date | null;
  checkoutEventId: string | null;
  plannedDate: Date | null;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

type BillingsPlanEntryTaxiDriverAddParams = {
  planEntryId: string;
  billingNodes: BillingsPlanEntryTaxiDriverAddParamsBillingNode[];
  billingContributions: BillingsPlanEntryTaxiDriverAddParamsContribution[];
};

export default BillingsPlanEntryTaxiDriverAddParams;
